import React from 'react';
import { motion } from 'framer-motion';
import { FaGooglePlay, FaApple } from "react-icons/fa";

const apps = [
  { name: "Delve", group: "Emerj LLC", desc: "AI language learning via voice-driven quests with 3D characters; paid subscriptions.", ios: "https://apps.apple.com/us/app/delve-ai-language-learning/id6745605474" },
  { name: "Deen AI", group: "Emerj LLC", desc: "Adhan, AI chat, and Qur'an companion app.", android: "https://play.google.com/store/apps/details?id=net.emerj.deenai&hl=en", ios: "https://apps.apple.com/us/app/deen-ai-adhan-ai-chat-quran/id6756240670" },
  { name: "Nora", group: "Emerj LLC", desc: "Motherhood AI companion app.", android: "https://play.google.com/store/apps/details?id=net.emerj.noramum&hl=en", ios: "https://apps.apple.com/us/app/nora-personal-mum-ai/id6756250549" },
  { name: "Sitelytics", group: "Emerj LLC", desc: "Part of the Emerj LLC consumer AI product suite.", android: "https://play.google.com/store/apps/details?id=net.emerj.sitelytics&hl=en", ios: "https://apps.apple.com/us/app/sitelytics/id6756032765" },
  { name: "ContentQ", group: "Emerj LLC", desc: "Part of the Emerj LLC consumer AI product suite.", android: "https://play.google.com/store/apps/details?id=net.emerj.contentq&hl=en", ios: "https://apps.apple.com/us/app/contentq/id6756614911" },
  { name: "StoryTime", group: "Emerj LLC", desc: "Part of the Emerj LLC consumer AI product suite.", android: "https://play.google.com/store/apps/details?id=net.emerj.storytime&hl=en" },
  { name: "Manifesti", group: "Emerj LLC", desc: "Part of the Emerj LLC consumer AI product suite.", android: "https://play.google.com/store/apps/details?id=net.emerj.manifesti&hl=en" },
  { name: "REA", group: "Emerj LLC", desc: "Part of the Emerj LLC consumer AI product suite.", android: "https://play.google.com/store/apps/details?id=net.emerj.rea&hl=en" },
  { name: "Farmex — Vendor", group: "Farmex", desc: "Two-sided agritech marketplace app for vendors.", android: "https://play.google.com/store/apps/details?id=com.farmex.vendor&hl=en" },
  { name: "Farmex — Agent", group: "Farmex", desc: "Two-sided agritech marketplace app for field agents.", android: "https://play.google.com/store/apps/details?id=com.afrifarmex.agent&hl=en" },
  { name: "iKook", group: "Marketplace", desc: "Chef-booking marketplace app.", android: "https://play.google.com/store/apps/details?id=com.ikook.ikook&hl=en" },
  { name: "PTML Management", group: "Enterprise", desc: "Internal operations app for PTML, one of Lagos's major port terminals — monitoring, task assignment, and management workflows. In production since 2020, with releases into 2026.", android: "https://play.google.com/store/apps/details?id=ptml.management&hl=en" },
  { name: "Keyguarde", group: "Utilities", desc: "Android utility app.", android: "https://play.google.com/store/apps/details?id=dev.logickoder.keyguarde&hl=en" },
  { name: "FuelCheck", group: "Utilities", desc: "Android utility app.", android: "https://play.google.com/store/apps/details?id=dev.logickoder.fuelcheck&hl=en" },
];

const MobileApps = () => {
  return (
    <div className="py-4" id="mobile">
      <div className="container2">
        <div className="sec-header mb-4 text-center">
          <h2 className="text-bold">Mobile Applications</h2>
          <p className="about-text text-muted">14 Published Apps on Google Play & the App Store</p>
        </div>
        <motion.div
          className="mobile-grid m-0"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          {apps.map((app) => (
            <motion.div
              className="mobile-card"
              key={app.name}
              whileHover={{ y: -4 }}
              transition={{ duration: 0.2 }}
            >
              <div className="d-flex align-items-start justify-content-between gap-2">
                <span className="flagship-tag">{app.group}</span>
                <div className="d-flex gap-2 store-links">
                  {app.android && (
                    <a href={app.android} target="_blank" rel="noopener noreferrer" aria-label={`${app.name} on Google Play`}>
                      <FaGooglePlay size={15} />
                    </a>
                  )}
                  {app.ios && (
                    <a href={app.ios} target="_blank" rel="noopener noreferrer" aria-label={`${app.name} on the App Store`}>
                      <FaApple size={17} />
                    </a>
                  )}
                </div>
              </div>
              <h6 className="fw-bold mt-2 mb-0">{app.name}</h6>
              <small className="text-muted">{app.desc}</small>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default MobileApps;
